import { createFileRoute } from '@tanstack/react-router';
import { Settings } from '@/pages';

/**
 * Settings Index Route (Protected)
 * The settings hub — navigation list with Account, Preferences, Privacy sections.
 */
export const Route = createFileRoute('/_authenticated/settings/')({
  component: Settings,
});
